export default __webpack_public_path__ + "static/media/general-bg-light-bottom.4e58e160.svg";